(function () {
    'use strict';

    angular
        .module(app.modules.app.name)
        .config(templateRequestConfig);

    templateRequestConfig.$inject = ['$httpProvider'];
    function templateRequestConfig($httpProvider) {
        var parser, cacheBuster;
        if (window.__timestamp) {
            cacheBuster = window.__timestamp;
            parser = document.createElement('a');
            $httpProvider.interceptors.push(templateInterceptor);
        }

        templateInterceptor.$inject = ['$templateCache'];
        function templateInterceptor($templateCache) {
            return { request: request };

            function request(config) {
                var url = config.url;
                parser.href = url;
                if (parser.pathname.endsWith(".html") && !$templateCache.get(url)) {
                    parser.search += (parser.search ? '&' : '?') + 'v=' + cacheBuster;
                    config.url = parser.href;
                    // console.log(config.url);
                }
                return config;
            }
        }
    }
})();